'use strict';

module.exports = require('./es2016');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/es7.js
// module id = 25
// module chunks = 0